import React, { useState } from 'react';
import { Heart, Loader2 } from 'lucide-react';
import { startCheckout } from '../lib/api';
import { useToast } from '../hooks/use-toast';

const AMOUNTS = [['donate_25', '$25'], ['donate_50', '$50'], ['donate_100', '$100'], ['donate_250', '$250']];

export const DonateButton = () => {
  const { toast } = useToast();
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(null);

  const donate = async (lookupKey) => {
    setBusy(lookupKey);
    try {
      const { checkout_url } = await startCheckout({ kind: 'donation', lookup_key: lookupKey });
      window.location.assign(checkout_url);
    } catch (err) {
      toast({ title: 'Could not start checkout', description: err.response?.data?.detail || err.message });
      setBusy(null);
    }
  };

  return (
    <div className="inline-flex flex-wrap items-center gap-1.5" data-testid="donate-widget">
      <button type="button" onClick={() => setOpen((v) => !v)} aria-expanded={open} data-testid="donate-toggle" className="inline-flex items-center gap-1 border border-[#f4b400] bg-[#f4b400] px-2.5 py-1.5 font-heading uppercase tracking-widest text-[9px] text-[#0a1f44] hover:bg-[#ffcf3d] transition-colors"><Heart className="w-3 h-3" /> Donate / Support the Patriots</button>
      {open && AMOUNTS.map(([key, label]) => (
        <button key={key} type="button" onClick={() => donate(key)} disabled={!!busy} data-testid={`donate-${key}`} className="inline-flex items-center gap-1 border border-white/60 px-2.5 py-1.5 font-heading uppercase tracking-widest text-[9px] text-white hover:bg-white hover:text-[#0a1f44] disabled:opacity-60 transition-colors">{busy === key ? <Loader2 className="w-3 h-3 animate-spin" /> : label}</button>
      ))}
    </div>
  );
};
